import FeedBackForm from '../components/FeedBack/FeedBackForm';

function FeedBack() {
  return <FeedBackForm />;
}

export default FeedBack;
